<style lang="less" scoped>
  .number {
    margin-top: 12px;
  }
  .start-button {
    margin-top: 24px;
  }
</style>

<template lang="pug">
  .time-number.std-layout
    .header
      header-component(
        @click-back='redirectBack'
        @click-start='start')
    .content
      title-component(:text='"숫자"')
    .footer
      number-component.number(
        :name='"숫자"'
        :unit='"개"'
        :min='1'
        :max='500'
        :default='500'
        @change='number = $event')
      number-component.number(
        :name='"시간"'
        :unit='"분"'
        @change='time = $event')
      number-component.number(
        :name='"단위"'
        :unit='"개"'
        :max='3'
        @change='units = $event')
      button-component.start-button(
        :text='"시작하기"'
        @click.native='start')
</template>

<script>
import HeaderComponent from '@/components/header/back_start';
import TitleComponent from '@/components/time_attack_title';
import ButtonComponent from '@/components/button';
import NumberComponent from '@/components/number';

import GameType from '@/game';

export default {
  data() {
    return {
      number: 500,
      time: 1,
      units: 1,
      mode: GameType.mode.time,
      game: GameType.game.number,
    };
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    start() {
      const answer = this.numberGame.init(this.number, this.units);
      this.$store.commit('setCount', this.number);
      this.$store.commit('setTime', this.time);
      this.$store.commit('setUnits', this.units);
      this.$store.commit('setMode', this.mode);
      this.$store.commit('setGame', this.game);
      this.$store.commit('setAnswer', answer);
      this.$router.push({ name: 'TimeNumberStart' });
    },
  },
  components: {
    HeaderComponent,
    TitleComponent,
    ButtonComponent,
    NumberComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/time/number/index.vue